import { type FieldDatatype } from '../../../datatype/Datatype.ts';

export enum AsyncServiceMethod {
  GET = 'GET',
  POST = 'POST',
  PUT = 'PUT',
}

export interface IAsyncService {
  id: string;
  name: string;
  url: string;
  method: AsyncServiceMethod;
  inputs: IAsyncServiceParameter[];
  outputs: IAsyncServiceParameter[];
  outputRoot: string | null | undefined;
  type: { id?: string | null; name?: string | null };
  /**
   * Se true, il servizio esterno è chiamato verso un url terzo all'applicazione (URL assoluto)
   * Se false, il servizio esterno è chiamato verso un endpoint facente parte dei microservizi dell'applicazione (URL relativo)
   */
  isExternal: boolean;
}

export interface IAsyncServiceParameter {
  name: string;
  sourcePath?: string | null;
  type: FieldDatatype;
}
